import { useMutation } from "@tanstack/react-query";
import { sendMail, sendBulkMailToCustomers } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useSendMail = () => {
  const { showNotification } = useNotification();
  return useMutation({
    mutationFn: (data) => sendMail(data),
    onSuccess: () => {
      showNotification("success", "Email sent successfully");
    },
    onError: (error) => {
      showNotification(
        "danger",
        error?.response?.data?.error || error?.response?.data?.message || "Failed to send email"
      );
    }
  });
};

export const useSendBulkMailToCustomers = () => {
  const { showNotification } = useNotification();
  return useMutation({
    mutationFn: sendBulkMailToCustomers,
    onSuccess: (data) => {
      const { sent, failed } = data?.data || {};
      showNotification("success", `Email sent to ${sent || 0} customer(s)${failed ? `, ${failed} failed` : ""}`);
    },
    onError: (error) => {
      showNotification("danger", error?.response?.data?.error || "Failed to send bulk email");
    },
  });
};
